import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map } from "rxjs";
import { hasAnyPagePermission } from "../../access-control/page-permissions/page-permissions";
import { pagePermissions } from "../../access-control/page-permissions/page-permissions.selectors";
import { NavigationMenuService } from "../../navigation/navigation-menu.service";
import { resolveLandingPageUrl } from "../landing-page/resolve-landing-page-url";

/**
 * Allows the role-assignment notice only when no page permission is granted.
 * Users without a recognized role resolve to this state (as does the temporary preview override).
 */
export const roleAssignmentRequiredGuard: CanActivateFn = () => {
    const globalStore = inject(Store);
    const router = inject(Router);
    const navigationMenuService = inject(NavigationMenuService);

    return globalStore.select(pagePermissions).pipe(
        filter((permissions) => permissions !== undefined),
        map((permissions) => {
            if (!permissions) {
                return false;
            }

            return !hasAnyPagePermission(permissions)
                ? true
                : resolveLandingPageUrl(navigationMenuService.userNavigationMenu(), router);
        }),
    );
};
